export const FETCH_ENTITIES_STARTED = 'entitiesView/FETCH_ENTITIES_STARTED';
export const STORE_ENTITIES = 'entitiesView/STORE_ENTITIES';
export const SET_PARAMS = 'entitiesView/SET_PARAMS';
export const SET_SELECTED_RESOURCE = 'entitiesView/SET_SELECTED_RESOURCE';
export const REPLACE_ENTITY = 'entitiesView/REPLACE_ENTITY';
export const CLEAR_DATA = 'entitiesView/CLEAR_DATA';
